import { html } from 'lit';
import componentStyles from './awards-block.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

/**
 * Awards Block.
 *
 * @element awards-block
 */

export default class AwardsBlock extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {

    return {
      images: { type: Object },
      /**
      * Heading
      */
      heading: { type: String },
    };
  }

  render() {
    return html`
      <div class="awards-block">
        <div class="awards-block__container">
          <div class="awards-block__left">
            <h2 class="awards-block__heading heading style--heading2 text-purple">${this.heading}</h2>
          </div>
          <div class="awards-block__right">
            <div class="awards-block__images">
              ${this.images.map(item => {
                return html`
                  <div class="image-wrapper">
                    <img src="${item.url}" title="${item.text}"/>
                  </div>
                `;
              })}
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-awards-block', AwardsBlock);
